import { useQuery } from '@tanstack/react-query'
import { ClientContractsService, ClientGetServiceAgreementOptions } from '../services'
import { APIContractClientDtoResponse } from '../types'
import { defaultQueryOptions } from './common'

export const useClientServiceAgreementContract = (
  locationName: string,
  options: ClientGetServiceAgreementOptions & { enabled?: boolean }
) => {
  const { hasSharedCRM, enabled = true } = options
  const defaultOptions = {
    enabled: !!locationName && enabled,
  }

  return useQuery<APIContractClientDtoResponse | null>({
    queryKey: ['clientServiceAgreementContract', locationName, hasSharedCRM],
    queryFn: () => ClientContractsService.listServiceAgreements(locationName, { hasSharedCRM }),
    ...defaultQueryOptions,
    ...defaultOptions,
  })
}
